import { FunctionComponent, HTMLAttributes } from 'react';

const IconZoomInFilled: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5858 20.5858C21.3668 19.8047 22.6332 19.8047 23.4142 20.5858L31.4142 28.5858C32.1953 29.3668 32.1953 30.6332 31.4142 31.4142C30.6332 32.1953 29.3668 32.1953 28.5858 31.4142L20.5858 23.4142C19.8047 22.6332 19.8047 21.3668 20.5858 20.5858Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 22C17.9706 22 22 17.9706 22 13C22 8.02944 17.9706 4 13 4C8.02944 4 4 8.02944 4 13C4 17.9706 8.02944 22 13 22ZM13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z"
      fill="currentcolor"
    />
    <path
      d="M11 9C11 7.89543 11.8954 7 13 7C14.1046 7 15 7.89543 15 9V17C15 18.1046 14.1046 19 13 19C11.8954 19 11 18.1046 11 17V9Z"
      fill="currentcolor"
    />
    <path
      d="M17 11C18.1046 11 19 11.8954 19 13C19 14.1046 18.1046 15 17 15H9C7.89543 15 7 14.1046 7 13C7 11.8954 7.89543 11 9 11H17Z"
      fill="currentcolor"
    />
  </svg>
);

export default IconZoomInFilled;
